"use strict";

if (!Array.isArray) {
  Array.isArray = function (arg) {
    return Object.prototype.toString.call(arg) === '[object Array]';
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/react-div-100vh/lib/polyfill.js
// module id = 349
// module chunks = 0